import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './ActionButton.module.css';

export enum ActionButtonVariant {
  Fold = 'Fold',
  Check = 'Check',
  Call = 'Call',
  BetOrRaise = 'BetOrRaise',
  AllIn = 'AllIn',
  Discard = 'Discard',
  WaitForBigBlindInactive = 'WaitForBigBlindInactive',
  WaitForBigBlindActive = 'WaitForBigBlindActive',
  PostBringIn = 'PostBringIn',
  Complete = 'Complete',
  TimeBank = 'TimeBank',
}

const ClassNamesMap = new Map([
  [ActionButtonVariant.Fold, styles.redButton],
  [ActionButtonVariant.Check, styles.greenButton],
  [ActionButtonVariant.Call, styles.greenButton],
  [ActionButtonVariant.BetOrRaise, styles.yellowButton],
  [ActionButtonVariant.AllIn, styles.AllIn],
  [ActionButtonVariant.Discard, styles.whiteButton],
  [ActionButtonVariant.WaitForBigBlindInactive, styles.whiteButton],
  [ActionButtonVariant.WaitForBigBlindActive, styles.purpleButton],
  [ActionButtonVariant.PostBringIn, styles.greenButton],
  [ActionButtonVariant.Complete, styles.yellowButton],
  [ActionButtonVariant.TimeBank, styles.greyButton],
]);

interface ActionButtonProps {
  variant: ActionButtonVariant;
  children: React.ReactNode;
  isDisabled?: boolean;
  isChecked?: boolean;
  isPlayerTurn: boolean;
  onClick: () => void;
  fullWidth?: boolean;
  className?: string;
  containerClassName?: string;
}

const ActionButton: FC<ActionButtonProps> = ({
  variant,
  children,
  isChecked,
  isPlayerTurn,
  onClick,
  className,
  containerClassName,
  fullWidth = false,
  isDisabled,
}) => {
  const classNames = twMerge(
    ClassNamesMap.get(variant),
    // isPlayerTurn || isChecked || variant === ActionButtonVariant.AllIn
    //   ? ClassNamesMap.get(variant)
    //   : "",
    !isPlayerTurn && !isChecked ? styles.inactive : '',
    isChecked && styles.checked,
    styles.button,
    // variant === ActionButtonVariant.Discard && !isPlayerTurn && styles.discardButtonWidth,
    fullWidth && '!w-64',
    className,
  );

  return (
    <div className={twMerge('w-full', containerClassName)}>
      <button disabled={isDisabled} className={twMerge('cursor-pointer', classNames)} onClick={onClick}>
        <span className={styles.buttonText}>{children}</span>
      </button>
    </div>
  );
};

export default ActionButton;
